var _rect, _g, _rect2, _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMalaysia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d0021b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 5.714
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.428,
    width: 120,
    height: 5.714
  }), /*#__PURE__*/React.createElement("rect", {
    y: 22.856,
    width: 120,
    height: 5.714
  }), /*#__PURE__*/React.createElement("rect", {
    y: 34.284,
    width: 120,
    height: 5.714
  }), /*#__PURE__*/React.createElement("rect", {
    y: 45.712,
    width: 120,
    height: 5.714
  }), /*#__PURE__*/React.createElement("rect", {
    y: 57.14,
    width: 120,
    height: 5.714
  }), /*#__PURE__*/React.createElement("rect", {
    y: 68.568,
    width: 120,
    height: 5.714
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45.7,
    fill: "#012a87"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 23,
    r: 14,
    fill: "#ffd100"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 23,
    r: 12,
    fill: "#012a87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 12l2.6 6.5 7-1.2-4.5 5.5 4.5 5.5-7-1.2L42 34l-2.6-6.5-7 1.2 4.5-5.5-4.5-5.5 7 1.2z",
    fill: "#ffd100"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/malaysia.fa2887c032324d16c34bc5c21b931c4d.svg";
export { ForwardRef as ReactComponent };